import React, { useEffect, useState } from "react";
import {
  abhaCartDownloadServices,
  createAbhaUserServices,
  UpdateAbhaUserServices,
} from "../../services";
import { useSelector } from "react-redux";
import "./abhacard.css";

/* ── Step marker images ── */
import step1Img from "../../assets/image/Group 110901.png";
import step2Img from "../../assets/image/Group 110902.png";
import step3Img from "../../assets/image/Group 110919.png";
import formBgImg from "../../assets/image/Group 2147206200.png";
import about from "../../assets/image/about_nha_pg_logo.png";

const STEPS = [
  {
    img: step1Img,
    title: "Verify Aadhaar Details",
    desc: "Enter your Aadhaar number and verify with OTP received on Aadhaar linked mobile number.",
  },
  {
    img: step2Img,
    title: "Link mobile number with ABHA",
    desc: "Enter your mobile number and verify with OTP to link with ABHA Address.",
  },
  {
    img: step3Img,
    title: "Create your ABHA",
    desc: "Create your ABHA Number with a unique ABHA address.",
  },
];

const AbhaCard = ({ setIsVerifiedMobile }) => {
  const [abhacarddata, setAbhacarddata] = useState("");
  const [showFull, setShowFull] = useState(false);
  const [abhaProfile, setAbhaProfile] = useState({});
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [updatePayload, setUpdatePayload] = useState(null);
  const [creating, setCreating] = useState(false);

  let userInfo = useSelector((state) => state.user.patientDetails);

  const existingAbha = JSON.parse(localStorage.getItem("existingAbha"));
  if (!existingAbha) {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (userData?.accounts?.length > 0) {
      userInfo = userData?.accounts[0];
    } else if (userData?.users?.length > 0) {
      userInfo = userData?.users;
    } else {
      userInfo = userData;
    }
  }

  const downloadabha = async () => {
    try {
      const tokenBody = {
        xToken:
          localStorage.getItem("abhaxtoken") ||
          localStorage.getItem("downloadToken"),
      };
      const response = await abhaCartDownloadServices({ body: tokenBody });
      setAbhacarddata(response.result);

      if (response.status) {
        setAbhaProfile(response.abhaProfile || {});

        const patientData = JSON.parse(localStorage.getItem("selectedIndex"));
        const aadharUser = JSON.parse(localStorage.getItem("aadhaarVerfiUser"));

        const dob = userInfo?.dob ? new Date(userInfo.dob) : null;
        const formattedDob = dob
          ? `${dob.getFullYear()}-${String(dob.getMonth() + 1).padStart(2, "0")}-${String(dob.getDate()).padStart(2, "0")}`
          : aadharUser?.abhaDOB || aadharUser?.dob || "";

        const payload = {
          patientId: patientData?.pId,
          abhaAddress:
            userInfo?.abhaAddress ||
            userInfo?.preferredAbhaAddress ||
            aadharUser?.abhaAddress,
          healthIdNumber:
            userInfo?.abhaNumber ||
            userInfo?.ABHANumber ||
            userInfo?.healthIdNumber ||
            aadharUser?.abhaNumber,
          abhaDOB:
            formattedDob ||
            userInfo?.abhaDOB ||
            userInfo?.dob ||
            aadharUser?.abhaDOB ||
            aadharUser?.dob,
          abhaGender: userInfo?.gender || aadharUser?.gender,
          abhaName:
            userInfo?.firstName || aadharUser?.firstName
              ? [
                  userInfo?.firstName || aadharUser?.firstName,
                  userInfo?.middleName || aadharUser?.middleName,
                  userInfo?.lastName || aadharUser?.lastName,
                ]
                  .filter(Boolean)
                  .join(" ")
              : userInfo?.name || userInfo?.fullName,
          abhaCard: response?.result,
          fname: userInfo?.firstName || userInfo?.fullName,
          mname: userInfo?.middleName || "",
          lname: userInfo?.lastName,
          dob:
            formattedDob ||
            userInfo?.dob ||
            aadharUser?.abhaDOB ||
            aadharUser?.dob,
          gender: userInfo?.gender || aadharUser?.gender,
          // fullname:
          //   userInfo?.firstName || aadharUser?.firstName
          //     ? [
          //         userInfo?.firstName || aadharUser?.firstName,
          //         userInfo?.middleName || aadharUser?.middleName,
          //         userInfo?.lastName || aadharUser?.lastName,
          //       ]
          //         .filter(Boolean)
          //         .join(" ")
          //     : userInfo?.fullName || userInfo?.name,
          abhaNumber: userInfo?.abhaNumber || userInfo?.ABHANumber,
          abhaAddress: userInfo?.abhaAddress || userInfo?.preferredAbhaAddress,
          mobile: userInfo?.mobile || aadharUser?.mobile,
          _hasPatientId: !!(patientData && patientData?.pId),
        };

        setUpdatePayload(payload);
        setShowProfileModal(true);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };

  const handleCreate = async () => {
    if (!updatePayload) return;
    try {
      setCreating(true);
      const { _hasPatientId, ...body } = updatePayload;
      let responsed;
      if (_hasPatientId) {
        responsed = await UpdateAbhaUserServices({ body });
      } else {
        responsed = await createAbhaUserServices({ body });
      }
      if (responsed?.status) {
        localStorage.clear();
        setShowProfileModal(false);
      }
    } catch (error) {
      console.error("Error saving ABHA user:", error);
    } finally {
      setCreating(false);
    }
  };

  const aabhacrt = "data:image/png;base64," + abhacarddata;

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = aabhacrt;
    link.download = "abha-card.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.location.reload();
  };

  useEffect(() => {
    downloadabha();
  }, []);

  return (
    <>
      <section className="lmop-section">
        <div className="container">
          <h2 className="lmop-left-title">Create ABHA Number in 3 Steps</h2>
          <p className="lmop-left-desc">
            Create ABHA and store all your medical records in one place. Take
            part in the{" "}
            <span className="highlight">
              Ayushman Bharat Digital Mission (ABDM)
            </span>{" "}
            and get started on your digital health journey.
          </p>

          <div className="row align-items-start g-4 g-lg-5">
            {/* ── LEFT: 3 Steps ── */}
            <div className="col-12 col-md-6">
              <div className="lmop-steps">
                {STEPS.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div className="lmop-step-item">
                      <div className="lmop-step-marker">
                        <img src={step.img} alt={`Step ${idx + 1}`} />
                      </div>
                      <div className="lmop-step-body">
                        <h4>{step.title}</h4>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                    {idx < STEPS.length - 1 && (
                      <div className="lmop-step-line" />
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* ── RIGHT: ABHA Card ── */}
            <div className="col-12 col-md-6">
              <div
                className="lmop-card-wrap"
                style={{
                  backgroundImage: `url(${formBgImg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="lmop-card-inner">
                  <h3 className="lmop-card-title">
                    ABHA created successfully!
                  </h3>


                  <div className="p-3 text-center">
                    <img
                      src={aabhacrt}
                      className="abha-card-download"
                      alt="ABHA Card"
                      onClick={() => setShowFull(true)}
                      style={{
                        cursor: "pointer",
                        maxWidth: "100%",
                        borderRadius: "10px",
                      }}
                    />
                  </div>

                  <button
                    type="button"
                    className="lmop-continue-btn"
                    onClick={handleDownload}
                  >
                    DOWNLOAD YOUR ABHA CARD NOW
                  </button>

                  <div className="lmop-nha-row">
                    <span className="lmop-nha-label">Approved by NHA</span>
                    <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Full Image Modal ── */}
      {showFull && (
        <div className="image-modal">
          <span className="close-btn2" onClick={() => setShowFull(false)}>
            &times;
          </span>
          <img src={aabhacrt} className="modal-content" alt="ABHA Card Full" />
        </div>
      )}

      {/* ── ABHA Profile Info Modal ── */}
      {showProfileModal &&
        (() => {
          const p = abhaProfile || {};
          const aadharUser =
            JSON.parse(localStorage.getItem("aadhaarVerfiUser")) || {};
          const genderRaw = p.gender || userInfo?.gender || aadharUser?.gender;
          const genderLabel =
            genderRaw === "M"
              ? "Male"
              : genderRaw === "F"
                ? "Female"
                : genderRaw || "-";

          const nameFromProfile = [p.firstName, p.middleName, p.lastName]
            .filter(Boolean)
            .join(" ");
          const nameFromUser = [
            userInfo?.firstName,
            userInfo?.middleName,
            userInfo?.lastName,
          ]
            .filter(Boolean)
            .join(" ");
          const nameFromAadhar = [
            aadharUser?.firstName,
            aadharUser?.middleName,
            aadharUser?.lastName,
          ]
            .filter(Boolean)
            .join(" ");

          const dobFromProfile =
            p.yearOfBirth && p.monthOfBirth && p.dayOfBirth
              ? `${p.yearOfBirth}-${String(p.monthOfBirth).padStart(2, "0")}-${String(p.dayOfBirth).padStart(2, "0")}`
              : p.dob || "";

          const rows = [
            {
              label: "ABHA Number",
              value:
                p.ABHANumber ||
                p.healthIdNumber ||
                p.abhaNumber ||
                userInfo?.ABHANumber ||
                userInfo?.abhaNumber ||
                userInfo?.healthIdNumber ||
                aadharUser?.abhaNumber ||
                "-",
            },
            {
              label: "Name",
              value:
                nameFromProfile ||
                p.name ||
                p.fullName ||
                nameFromUser ||
                userInfo?.fullName ||
                userInfo?.name ||
                nameFromAadhar ||
                "-",
            },
            {
              label: "DOB",
              value:
                dobFromProfile ||
                userInfo?.dob ||
                aadharUser?.dob ||
                aadharUser?.abhaDOB ||
                "-",
            },
            {
              label: "Mobile",
              value: p.mobile || userInfo?.mobile || aadharUser?.mobile || "-",
            },
            { label: "Email", value: p.email || userInfo?.email || "-" },
            { label: "Gender", value: genderLabel },
            { label: "Address", value: p.address || userInfo?.address || "-" },
            {
              label: "State",
              value: p.stateName || userInfo?.stateName || "-",
            },
            {
              label: "District",
              value: p.districtName || userInfo?.districtName || "-",
            },
            {
              label: "Block",
              value:
                p.subDistrictName ||
                p.blockName ||
                userInfo?.subDistrictName ||
                "-",
            },
            {
              label: "Village/Town",
              value:
                p.villageName || p.townName || userInfo?.villageName || "-",
            },
            { label: "Pincode", value: p.pincode || userInfo?.pincode || "-" },
            {
              label: "ABHA Address",
              value:
                p.preferredAbhaAddress ||
                p.abhaAddress ||
                userInfo?.preferredAbhaAddress ||
                userInfo?.abhaAddress ||
                aadharUser?.abhaAddress ||
                "-",
            },
          ];

          return (
            <div
              className="abha-profile-modal-overlay"
              onClick={() => setShowProfileModal(false)}
            >
              <div
                className="abha-profile-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="abha-profile-close-btn"
                  onClick={() => setShowProfileModal(false)}
                >
                  &times;
                </button>
                <h4 className="abha-profile-modal-title">
                  ABHA Profile Details
                </h4>
                <div className="abha-profile-table">
                  {rows.map((row) => (
                    <div className="abha-profile-row" key={row.label}>
                      <span className="abha-profile-label">{row.label}:</span>
                      <span className="abha-profile-value">{row.value}</span>
                    </div>
                  ))}
                </div>
                <div className="abha-profile-btn-row">
                  <button
                    className="abha-profile-skip-btn"
                    onClick={() => setShowProfileModal(false)}
                    disabled={creating}
                  >
                    Skip
                  </button>
                  <button
                    className="abha-profile-create-btn"
                    onClick={() => {
                      handleCreate();
                     setShowProfileModal(false)
                    }}
                    disabled={creating}
                  >
                    {creating ? "Creating..." : "Create"}
                  </button>
                </div>
              </div>
            </div>
          );
        })()}
    </>
  );
};

export default AbhaCard;
